export default {
    bot_description: "Бот сипаттамасы",
    bot_name: "Бот атауы",
    clinic_account: "Клиника аккаунты",
    clinic_site_link: "Клиниканың сайтына сілтеме",
    code_for_bonus_payment: "Бонустармен төлеу үшін код",
    code_was_not_sent: "Код жіберілмеген - пациентке жеделхаттың ботқа қосылғанын тексеру қажет",
    code_was_sent_to_patient_through_bot: "Код пациентке боттың телеграммы арқылы жіберілді",
    connected_to_telegram_bot: "Бот телеграммына қосылды",
    max_bot: "Max bot",
    telegram_bot: "Telegram bot",
    telegram_bot_default_description: "Бот клиника пациенттеріне бонустар жинауға және келулер туралы өзекті ақпарат алуға көмектеседі",
    telegram_bot_instruction_1: "Telegram мессенджерін ашып, тіркелгіңізге кіріңіз немесе жаңасын жасаңыз. Іздеу өрісіне енгізіңіз <code>{'@'}BotFather</code> және ботты таңдаңыз",
    telegram_bot_instruction_2: "Пәрменді таңдау немесе басып шығару және жіберу <code>/newbot</code>",
    telegram_bot_instruction_3: "Ботқа атау беріңіз - бұл атауды клиенттер ботпен сөйлескенде көреді. Боттың атауы - ол бойынша ботты Telegram-дан табуға болады. Атауы бірегей болуы керек, дерекқорда бар сөздерді қайталамауы керек және bot сөзімен аяқталуы керек",
    telegram_bot_instruction_4: "Жасалған боттың токен мәнін көшіріп, төмендегі өріске қойыңыз және сақтаңыз",
    use_bonuses_by_confirming_through_telegram_bot: "Телеграм боты арқылы расталған бонустарды есептен шығару",
    wrong_code: "Код қате"
}
